import React from 'react';

import { Box, Grid2 as Grid } from '@mui/material';

import { Resource } from '../../../../../common/constants/resource';

type AutoMedicalClaimsReasonSectionProps = {
  evidenceReasons: string[];
  reasonDescription?: string;
};

export const AutoMedicalClaimsReasonSection = ({
  evidenceReasons,
  reasonDescription,
}: AutoMedicalClaimsReasonSectionProps) => {
  if (!evidenceReasons?.length && !reasonDescription) {
    return null;
  }

  return (
    <Box className="auto-medical-claims-reason-section">
      <Grid container spacing={1}>
        <Grid size={{ xs: 12 }}>
          <div className="auto-medical-claims-reason-label">
            {Resource.REASON}
          </div>
        </Grid>
        <Grid size={{ xs: 3 }}>
          <div className="auto-medical-claims-reason-label">
            {Resource.EVIDENCE}
          </div>
        </Grid>
        <Grid size={{ xs: 9 }}>
          <Box className="auto-medical-claims-reason-value-indent">
            <div className="auto-medical-claims-reason-value">
              {evidenceReasons?.length
                ? evidenceReasons.join(Resource.NORA_SEPARATOR)
                : Resource.NA}
            </div>
          </Box>
        </Grid>
        <Grid size={{ xs: 3 }}>
          <div className="auto-medical-claims-reason-label">
            {Resource.DESCRIPTION}
          </div>
        </Grid>
        <Grid size={{ xs: 9 }}>
          <Box className="auto-medical-claims-reason-value-indent">
            <div className="auto-medical-claims-reason-value">
              {reasonDescription || Resource.NA}
            </div>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
